module.exports = __webpack_public_path__ + "static/media/ic-phone.226a93fd.svg";